'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  COMPANY: 'company',
  CUSTOMER: 'customer'
};
module.exports = exports['default'];